/**
 * StatusFilter Component - T112
 *
 * Pills-based status filter for invoices
 */
import { InvoiceStatusBadge } from './InvoiceStatusBadge';
import type { InvoiceStatus } from '../../hooks/useInvoices';

// 'open' (Codex-006) = offene Forderungen (sent+overdue); a synthetic filter
// value, not a raw InvoiceStatus, so it renders as a text pill like all/active.
type StatusFilterValue = InvoiceStatus | 'all' | 'active' | 'open';

interface StatusFilterProps {
  value: StatusFilterValue;
  onChange: (status: StatusFilterValue) => void;
}

const statusFilters: { value: StatusFilterValue; label: string }[] = [
  { value: 'active', label: 'Aktiv' },
  { value: 'open', label: 'Offen' },
  { value: 'all', label: 'Alle' },
  { value: 'draft', label: 'Entwürfe' },
  { value: 'sent', label: 'Gesendet' },
  { value: 'paid', label: 'Bezahlt' },
  { value: 'overdue', label: 'Überfällig' },
  { value: 'deferred', label: 'Zurückgestellt' },
  { value: 'cancelled', label: 'Storniert' },
];

export function StatusFilter({ value, onChange }: StatusFilterProps) {
  return (
    <div className="overflow-x-auto -mx-4 px-4 lg:mx-0 lg:px-0">
      <div className="flex gap-2 min-w-max lg:flex-wrap" role="group" aria-label="Status Filter">
        {statusFilters.map((filter) => (
          <button
            key={filter.value}
            onClick={() => onChange(filter.value)}
            className={`px-2.5 py-1 rounded-full text-sm transition-colors whitespace-nowrap !min-w-0 !min-h-0 ${
              value === filter.value
                ? 'bg-white/10 text-white ring-1 ring-white/20'
                : 'text-white/50 hover:text-white hover:bg-white/5'
            }`}
            aria-pressed={value === filter.value}
          >
            {filter.value === 'all' || filter.value === 'active' || filter.value === 'open' ? (
              filter.label
            ) : (
              <InvoiceStatusBadge status={filter.value} />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
